import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const SubscribeWrapper = styled.div`
  display: grid;
  column-gap: 16px;
  margin: 20px 0;
  grid-template-columns: 1fr 1fr;
  @media (max-width: ${defaultBreakpoints.medium}) {
    grid-template-columns: 1fr;
  }
`;
